import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Bugsnag from '@bugsnag/js'

import { NODE_ENV } from './helpers/utils'
import de from './i18n/de.json'
import en from './i18n/en.json'
import nl from './i18n/nl.json'
import fr from './i18n/fr.json'

const resources = {
  en: {
    translation: en
  },
  de: {
    translation: de
  },
  nl: {
    translation: nl
  },
  fr: {
    translation: fr
  },
  common: {
    // use an empty object to detect not available keys
    translation: {}
  }
}

// <html lang> mitziehen, damit Screenreader und Browser NL/FR richtig erkennen
i18n.on('languageChanged', (language) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = language
  }
})

i18n
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: 'common',
    debug: NODE_ENV === 'development',
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    saveMissing: true,
    missingKeyHandler: (_, __, key) => {
      if (NODE_ENV === 'development') return

      Bugsnag.leaveBreadcrumb('i18n missing key', { key }, 'log')
    }
  })

export default i18n
